// extracted by mini-css-extract-plugin
export default {"recos":"l5-z","productCardOverride":"m5-z","rowHasBadge":"n5-z"};